/**
 * 現在位置関係
 * TODO: v5で廃止したい
 * 
 * ref. http://plebeosaur.us/here-we-are-again/
 * 
 * events:
 *   ihWatchPosition
 *   
 * @depends IH, IHCompass(optional)
 * @type IHGeolocation._L4.klass
 */
module.exports = (function(){
  var klass = function(){
    this.initialize.apply(this, arguments);
  };
  klass.extended = function(that){
    that.translationsGL = that.translationsCommon.geolocation;
    
    $(that).on('ready', function(){
      // app?gps_lat=***&gps_lng=***
      // var qs = this.getQueryString();
      // if (qs.gps_lat && qs.gps_lng){
      //   that.setGeolocationMock({lat: qs.gps_lat, lng: qs.gps_lng});
      //
      // }
    });
  };
  klass.prototype = {
    'dummy': 'dummy'
    , geolocationMock: null
    , geolocationWatchId: null
    , geolocationPulseMarker: null
    , geolocationWatchOptions: {
        enableHighAccuracy: true,    // 高精度を要求する
        timeout: 60000,              // 最大待ち時間（ミリ秒）
        maximumAge: 0                // キャッシュ有効期間（ミリ秒）
    }
    /**
     * 実験用、現在地のすり替え
     */
    , setGeolocationMock: function(latlng){
      this.geolocationMock = {
        coords: {
          latitude: latlng.lat,
          longitude: latlng.lng
        }
      };
    }
    /**
     * 
     * @returns {jQuery.Deferred}
     */
    , shiftToLocationMode: function(){
      var that = this;
      
      if (!navigator.geolocation) {
        alert(that.translationsGL.outOfService);
        return;
      }
      
      this.displayLoading(true);

      if (this.geolocationWatchId){
        navigator.geolocation.clearWatch(this.geolocationWatchId);
        this.geolocationWatchId = null;
      }
      
      return this.moveByGeolocation().then(function(position){
        // 位置情報取得できた
        that.search_method_prev_num = 2; // TODO これ何
        
        //that.map.moveMap(position.coords.latitude, position.coords.longitude);
        let lat = position.coords.latitude;
        let lng = position.coords.longitude;
        
        // 現在地機能の範囲制限が有効な場合
        if (that.geolocationBounds) {
          if (
            lat < that.geolocationBounds.minLat ||
            lng < that.geolocationBounds.minLng ||
            lat > that.geolocationBounds.maxLat ||
            lng > that.geolocationBounds.maxLng){
            alert(that.translationsExtend.geolocation.oufOfArea);
            return;
          }
        }
        
        let latlng = that.map.createLatLng(lat, lng);
        that.map.setCenterAndCurrentLocation(latlng);
        $(that.map).trigger('ihUpdateCenterMarker');
        
      }).fail(function(obj){
        // 位置情報取得できなかった
        alert(obj['msg']);
      }).always(function(){
        // 何か結果が帰ってきた
        that.displayLoading(false);
      });
      
    }
    /**
     * 
     * @type {Function} (Geoposition) -> id
     */
    , watchPositionFunc: function(){
      var that = this;
      if (that.geolocationMock){
        // Returns mock function
        return function(callback){
          callback(that.geolocationMock);
          // No return watch id
          return null;
        };
      }else{
        return function(callback){
          // watchPositionを変数に入れるとillegal invocationになる
          return navigator.geolocation.watchPosition(callback);
        };
      }
    }
    /**
     * 位置情報を使って地図を検索する
     * 
     * @returns {jQuery.Deferred}
     */
    , moveByGeolocation: function() {
      var that = this,
        df = jQuery.Deferred();

      this.geolocationWatchId = that.watchPositionFunc()(function(position){
        that.handleWatchingGeolocation(position);
         // タイマーなのでここは何度も実行するが、resolveした時のthenは一度だけ実行される
        df.resolve(position);
      }, function(){
        df.reject({msg: that.translationsGL.fail});
      }, that.geolocationWatchOptions);
      
      df.then(function(position){
        $(that).trigger('ihStartWatchingPosition', [position]);
      });
      return df;
    }
    /**
     * 位置情報を更新した時
     * 
     * @param {type} position
     * @returns {undefined}
     */
    , handleWatchingGeolocation: function(position){
      if (this.renderPulse){
        this.renderPulse(position);
      }
      if (this.renderCompass){
        this.renderCompass(position);
      }
      $(this).trigger('ihWatchPosition', [position]);
    }
    /**
     * 現在地を描画する
     * 
     * @param {type} position
     * @returns {undefined}
     */
    , renderPulse: function(position){
        /**
         * position: 
            coords: 
              accuracy: 37
              altitude: null
              altitudeAccuracy: null
              heading: null
              latitude: 34.7373338
              longitude: 135.5245306
              speed: null
         */
      // accuracyを元に円描きたい
      
      var 
        that = this,
      
        // create a new LatLng object for every position update
        myLatLng = new google.maps.LatLng( position.coords.latitude, position.coords.longitude );

      // build entire marker first time thru
      if ( !that.geolocationPulseMarker ) {
        // then create the new marker
        that.geolocationPulseMarker = that.createGeolocationPulseMarker();

      // just change marker position on subsequent passes
      }
      that.geolocationPulseMarker.setPosition( myLatLng );
      
    }
    /**
     * 現在地用のマーカーを生成
     * 
     * @returns {google.maps.Marker}
     */
    , createGeolocationPulseMarker: function(){
      
      var
        map = this.gmap,
      
      // define our custom marker image
        image = new google.maps.MarkerImage(
          'img/bluedot.png',
          null, // size
          null, // origin
          new google.maps.Point( 8, 8 ), // anchor (move to center of marker)
          new google.maps.Size( 17, 17 ) // scaled size (required for Retina display icon)
        ),
        marker = new google.maps.Marker({
          flat: true,
          icon: image,
          map: map,
          optimized: false,
          title: 'I might be here',
          visible: true,
          zIndex: 200
        });                  

      return marker;
    }
  }
  return klass;
  
})();



// WEBPACK FOOTER //
// ./map/js/ih/ih.geolocation.js